<template>
  <div class="BaseSetLine">
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>样式设置</span>
      </div>
      <ul class="imgType">
        <li>
          <el-image :class="styleData.type === 'COMMON'?'active':''" @click="changeImgType('COMMON')" :src="require('@/assets/images/linea.png')" fit="cover"></el-image>
          <div class="name">普通</div>
          <div class="check" v-if="styleData.type === 'COMMON'"><img src="~@/assets/images/xuanze.png" alt=""></div>
        </li>
        <li>
          <el-image :class="styleData.type === 'WALL'?'active':''" @click="changeImgType('WALL')" :src="require('@/assets/images/lineb.png')" fit="cover"></el-image>
          <div class="name">围墙</div>
          <div class="check" v-if="styleData.type === 'WALL'"><img src="~@/assets/images/xuanze.png" alt=""></div>
        </li>
      </ul>
<!--    普通-->
      <div v-show="styleData.type==='COMMON'">
        <div class="form-item">
          <div class="label">线型</div>
          <!-- <el-input value="实线" readonly>
            <span slot="suffix" style="width: 0.5rem;display: inline-block;height: 1px;background-color: #ffffff;transform: translateY(-4px)"></span>
          </el-input> -->
          <el-select v-model="styleData.linear" placeholder="请选择"  @change="changeLineType" ref="refSelect" :popper-append-to-body="false" style="background-color: #424243;border-radius: 6px">
            <el-option
              v-for="(item,index) in lineTypeOptions"
              :key="index"
              :label="item.label"
              :value="item.value">
              <span>{{item.label}}</span>
              <img :src="item.img" style="margin-left:40px"/>
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">颜色</div>
          <el-input v-model="styleData.color" placeholder="请输入内容" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.color" @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">宽度</div>
          <div class="slider">
            <span class="text" style="color: #ffffff;margin-right: 0.18rem">{{styleData.width}}</span>
            <el-slider v-model="styleData.width" :max="10" :show-tooltip="false" @change="onValueChange"></el-slider>
          </div>
        </div>
        <div class="form-item">
          <div class="label">开启鼠标进入高亮</div>
          <el-switch
            v-model="styleData.isHover"
            active-color="#00A4F0"
            inactive-color="#494B4D"
            @change="onValueChange">
          </el-switch>
        </div>
      </div>
<!--    围墙-->
      <div v-show="styleData.type==='WALL'">
        <div class="form-item">
          <div class="label">高度</div>
          <div class="slider">
            <span class="text" style="color: #ffffff;margin-right: 0.18rem">{{styleData.height}}</span>
            <el-slider v-model="styleData.height" :min="1" :max="100" :show-tooltip="false" @change="onValueChange"></el-slider>
          </div>
        </div>
        <div class="form-item">
          <div class="label">颜色</div>
          <el-input v-model="styleData.color" placeholder="请输入内容" @change="onValueChange">
            <ColorPicker slot="suffix" v-model="styleData.color" @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">纹理</div>
          <el-select v-model="styleData.texture" placeholder="请选择" ref="textureSelect" :popper-append-to-body="false" @change="changeTextureType">
            <el-option
              v-for="item in wallTextureOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              <span>{{item.label}}</span>
              <img v-if="!!item.img" :src="item.img" style="margin-left:40px"/>
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">动效</div>
          <el-select v-model="styleData.dynamicEffect" placeholder="请选择" :popper-append-to-body="false" @change="onValueChange">
            <el-option
              v-for="item in wallEffectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
<!--      <div class="form-item">-->
<!--        <div class="label">标签字段</div>-->
<!--        <el-select v-model="styleData.label" placeholder="请选择" @change="onValueChange">-->
<!--          <el-option-->
<!--              v-for="item in labelProperties"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
    </div>
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>标签样式</span>
      </div>
      <div>
        <div class="form-item">
          <div class="label">标签字段</div>
          <el-select v-model="styleData.label" placeholder="请选择" :popper-append-to-body="false" @change="onLabelChange">
            <el-option
                    v-for="item in labelProperties"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">标签显示</div>
          <el-select v-model="styleData.showLabelType" placeholder="请选择" :disabled="styleData.label === 'empty'" :popper-append-to-body="false" @change="onValueChange">
            <el-option
                    v-for="item in labelShowOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">字体类型</div>
          <el-select v-model="styleData.labelStyle.labelFont" placeholder="请选择" :popper-append-to-body="false" @change="onValueChange">
            <el-option
                    v-for="item in fontFamilyList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <div class="label">字体颜色</div>
          <el-input v-model="styleData.labelStyle.labelColor" placeholder="请选择" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelColor"  @changeColor="onValueChange" :showAlpha="false"></ColorPicker>
          </el-input>
        </div>
        <div class="form-item">
          <div class="label">背景颜色</div>
          <el-input v-model="styleData.labelStyle.labelBackgroundColor" placeholder="请选择" @change="onValueChange" disabled>
            <ColorPicker slot="suffix" v-model="styleData.labelStyle.labelBackgroundColor" @changeColor="onValueChange"></ColorPicker>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/ColorPicker/ColorPicker'
export default {
  name: 'BaseSetLine',
  props: {},
  components: { ColorPicker },
  data () {
    return {
      // 样式属性
      styleData: {
        type: undefined,
        linear: undefined,
        color: undefined,
        width: undefined,
        height: undefined,
        texture: undefined,
        dynamicEffect: undefined,
        label: undefined,
        isHover: false,
        showLabelType: 'hide',
        labelStyle: {
          labelFont: undefined,
          labelColor: undefined,
          labelBackgroundColor: undefined
        }
      },
      properties: undefined,
      fontFamilyList: [{
        value: '宋体',
        label: '宋体'
      }, {
        value: '楷体',
        label: '楷体'
      }, {
        value: '黑体',
        label: '黑体'
      }],
      labelShowOptions: [{
        value: 'hide',
        label: '不显示'
      }, {
        value: 'show',
        label: '常显'
      }, {
        value: 'distance',
        label: '层级显示'
      }],
      // 围墙纹理
      wallTextureOptions: [
        {
          value: 'empty',
          label: '无',
          img: undefined
        },
        {
          value: 'arrow',
          label: '箭头',
          img: require('@/assets/images/jiantou-a.png')
        },
        {
          value: 'line',
          label: '线条',
          img: require('@/assets/images/xiantiao-a.png')
        }
      ],
      // 围墙动画
      wallEffectOptions: [{
        value: 'empty',
        label: '无'
      }, {
        value: 'horizontal',
        label: '水平'
      }, {
        value: 'vertical',
        label: '垂直'
      }],
      lineTypeOptions: [
        {
          value: 'solid',
          label: '实线',
          img: require('@/assets/images/shixian.png')
        },
        {
          value: 'dash',
          label: '虚线',
          img: require('@/assets/images/xuxian.png')
        },
        {
          value: 'arrow',
          label: '箭头',
          img: require('@/assets/images/jiantou.png')
        }
      ]
    }
  },
  computed: {
    // bindLabel: {
    //   get: function () {
    //     if (!this.styleData.label) {
    //       return undefined
    //     }
    //     return parseInt(this.styleData.label)
    //   },
    //   set: function (value) {
    //     this.styleData.label = value
    //   }
    // },
    labelProperties () {
      const properties = [{
        id: 'empty',
        name: '无'
      }, {
        id: 'markerName',
        name: '标注名称'
      }
      // , {
      //   id: 'index',
      //   name: '序号'
      // }
      ]
      if (this.properties) {
        for (let i = 0; i < this.properties.length; i++) {
          properties.push({
            id: this.properties[i].id.toString(),
            name: this.properties[i].name
          })
        }
      }
      return properties
    }
  },
  methods: {
    setData (styleData, data) {
      this.styleData = styleData
      this.properties = data.properties
      this.$nextTick(() => {
        this.setLineStyle(this.styleData.linear)
        this.setTextureStyle(this.styleData.texture)
      })
    },
    // 设置线条样式
    setLineStyle (value) {
      let index = 0
      for (let i = 0; i < this.lineTypeOptions.length; i++) {
        if (value === this.lineTypeOptions[i].value) {
          index = i
        }
      }
      const img = this.lineTypeOptions[index].img
      this.$refs.refSelect.$el.children[0].children[0].setAttribute(
        'style',
          `
          background: url(${img}) no-repeat;
          background-position: 70px center;
          background-size: 50px 7px;
          background-color: rgba(255, 255, 255, 0.1);
          `
      )
    },
    setTextureStyle (value) {
      if (!this.$refs.textureSelect) {
        return
      }
      let index = 0
      for (let i = 0; i < this.wallTextureOptions.length; i++) {
        if (value === this.wallTextureOptions[i].value) {
          index = i
        }
      }
      const img = this.wallTextureOptions[index].img
      this.$refs.textureSelect.$el.children[0].children[0].setAttribute(
        'style',
          `
          background: url(${img}) no-repeat;
          background-position: 70px center;
          background-size: 50px 13px;
          background-color: rgba(255, 255, 255, 0.1);
          `
      )
    },
    changeLineType (value) {
      this.setLineStyle(value)
      this.$emit('layerStyleChanged', true)
    },
    changeTextureType (value) {
      this.setTextureStyle(value)
      this.$emit('layerStyleChanged', true)
    },
    changeColor (v) {
      this.$emit('layerStyleChanged', true)
    },
    // 属性值修改
    onValueChange () {
      this.$emit('layerStyleChanged', true)
    },
    // 修改样式类型
    changeImgType (type) {
      this.styleData.type = type
      this.$emit('layerStyleChanged', true)
    },
    onLabelChange () {
      if (this.styleData.label === 'empty') {
        this.styleData.showLabelType = 'hide'
      }
      this.$emit('layerStyleChanged', true)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .BaseSetLine{
    text-align: left;
    .title{
      color: #FFFFFF;
      font-size: 14px;
      margin-bottom: 15px;
      >.line{
        display: inline-block;
        margin-right: 4px;
        width: 3px;
        height: 10px;
        background: #00A4F0;
        border-radius: 2px;
      }
    }
    .el-input .el-input__inner{
      font-size: 12px !important;
      height: 32px !important;
    }
    .el-input__prefix{
      display: flex;
      align-items: center;
      padding-left: 10px;
      >img{
        width: 15px;
        height: 15px;
      }
    }
    .el-radio-group{
      width: 155px;
      display: flex;
      .el-radio{
        margin-right: 30px;
        transform: scale(0.9);
      }
    }
    .baseInfo{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .form-item{
        margin-bottom: 16px;
        >.label{
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          margin-bottom: 8px;
        }
      }
      .type{
        margin-bottom: 5px;
        .label{
          font-size: 13px;
          color: rgba(255, 255, 255, 0.3);
        }
        .value{
          font-size: 13px;
          color: #00A4F0;
        }
      }
    }
    .styleSetting{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .imgType{
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 0 0;
        >li{
          width: 60px;
          height: 90px;
          border-radius: 6px;
          position: relative;
          margin-right: 12px;
          .el-image{
            width: 60px;
            height: 60px;
            border-radius: 6px;
            cursor: pointer;
            border: 2px solid rgba(0, 164, 240, 0);
            box-sizing: border-box;
            &.active{
              border: 2px solid rgba(0, 164, 240, 0.94);
              box-shadow: 0 0 7px rgba(25, 195, 240, 0.9);
            }
          }
          img{
            width: 100%;
            height: 100%;
          }
          .name{
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
            transform: translateY(-2px);
          }
          .check{
            position: absolute;
            right: 0;
            top: 40px;
          }
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .label{
          width: 120px;
          font-size: 12px;
          color: #999999;
        }
        .slider{
          width: 230px;
          height: 32px;
          background: #424243;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;
          .el-slider{
            width: 100%;
            .el-slider__runway{
              height: 4px;
            }
            .el-slider__bar{
              height: 4px;
              background-color: $primary-color;
            }
            .el-slider__button{
              width: 8px;
              height: 8px;
              border: solid 0.02rem #ffffff;
              background-color: $primary-color;
              transform: translateY(-1px);
            }
          }
        }
      }
    }
  }
</style>
